export const namespace = 'userPreferences'
